(() => {
  'use strict';

  const GROUPS = {
    'japanese':['japanese','japan','tokyo','anime','manga','samurai','kanagawa','great wave'],
    'cherry-blossom':['cherry blossom','sakura'],
    'funny':['funny','novelty','meme','joke','humour','humor','cheeky'],
    'gothic':['goth','gothic','skull','dark','occult'],
    'streetwear':['streetwear','street wear','urban','oversized'],
    'sports':['football','f1','formula 1','formula one','motorsport','boxing','ufc','sport','team'],
    'adhd':['adhd'],
    'vintage':['vintage','retro','90s','80s','70s','classic'],
    'animals':['animal','capybara','dog','cat','wildlife','pet'],
    'cities':['city','cities','london','birmingham','manchester','tokyo','new york','paris','rome'],
    'aston-villa':['aston villa','aston-villa','avfc','villa'],
    'tottenham':['tottenham','spurs','thfc'],
    'holte-end':['holte end','holte-end'],
    'match-day':['match day','matchday','match-day'],
    'kids':['kids','kid','child','children','youth','baby','toddler'],
    'jumpers':['jumper','sweatshirt'],
    't-shirts':['t-shirt','t shirt','tee','shirt'],
    'mclaren':['mclaren'],
    'red-bull':['red bull','red-bull'],
    'mercedes':['mercedes'],
    'ferrari':['ferrari'],
    'lando-norris':['lando','norris'],
    'verstappen':['verstappen','max verstappen'],
    'f1':['f1','formula 1','formula one','motorsport'],
    'capybara':['capybara'],
    'personalised':['personalised','personalized','custom','name','photo'],
    'black':['black'],
    'adult':['adult','unisex','mens','women','womens','men'],
    'football':['football','villa','spurs','avfc','tottenham'],
    'mothers-day':['mother','mothers day',"mother's day",'mum','mom'],
    'fathers-day':['father','fathers day',"father's day",'dad'],
    'hoodies':['hoodie'],
    'pets':['pet','dog','cat'],
    'hi-vis':['hi vis','hi-vis','high visibility','high-vis'],
    'softshells':['softshell','soft shell'],
    'gilets-bodywarmers':['gilet','bodywarmer','body warmer'],
    'trousers':['trouser','trousers','work pant','work pants'],
    'safety-vests':['safety vest','hi vis vest','high visibility vest'],
    'pyjamas':['pyjama','pyjamas','pajama','pajamas','pjs','pj']
  };

  const matchesStyle = (card, key) => {
    if (!key) return true;
    const terms = GROUPS[key] || [key.replace(/-/g, ' ')];
    const blob = (card.dataset.v27Style || '').toLowerCase();
    return terms.some(term => blob.includes(term));
  };

  document.querySelectorAll('[data-v27-style-filters]').forEach(nav => {
    const section = nav.closest('[data-v27-collection]');
    if (!section) return;
    const cards = Array.from(section.querySelectorAll('.pv27-product-card[data-v27-style]'));
    const empty = section.querySelector('[data-v27-style-empty]');
    const buttons = Array.from(nav.querySelectorAll('[data-v27-style-filter]'));
    if (!cards.length || !buttons.length) return;

    nav.addEventListener('click', event => {
      const button = event.target.closest('[data-v27-style-filter]');
      if (!button || !nav.contains(button)) return;
      const key = (button.dataset.v27StyleFilter || '').toLowerCase();

      buttons.forEach(item => {
        const isActive = item === button;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      cards.forEach(card => {
        card.dataset.pv27StyleHidden = matchesStyle(card, key) ? 'false' : 'true';
      });

      if (window.PV27CollectionFilters?.reconcile) {
        window.PV27CollectionFilters.reconcile();
      } else {
        let visible = 0;
        cards.forEach(card => {
          const show = card.dataset.pv27StyleHidden !== 'true';
          card.hidden = !show;
          if (show) visible += 1;
        });
        if (empty) empty.hidden = !key || visible > 0;
      }
    });
  });
})();

(() => {
  'use strict';

  const dataNode = document.getElementById('pv27-collection-filter-data');
  const section = document.querySelector('[data-v27-collection]');
  const toolbar = section?.querySelector('.pv27-collection-toolbar');
  if (!dataNode || !section || !toolbar || toolbar.querySelector('.pv27-filter-panel')) return;

  let data;
  try {
    data = JSON.parse(dataNode.textContent || '{"products":[]}');
  } catch (error) {
    console.warn('[Printora V27] Collection filter data could not be read', error);
    return;
  }

  const products = Array.isArray(data?.products) ? data.products : [];
  const cards = Array.from(section.querySelectorAll('.pv27-product-card'));
  if (!products.length || !cards.length) return;

  const productByPath = new Map();
  products.forEach(product => {
    try {
      productByPath.set(new URL(product.url, location.origin).pathname, product);
    } catch (_) {}
  });

  const cardEntries = cards.map(card => {
    const link = card.querySelector('.pv27-product-card__media[href], h2 a[href]');
    if (!link) return null;
    let pathname = '';
    try { pathname = new URL(link.href, location.origin).pathname; } catch (_) {}
    return { card, product: productByPath.get(pathname) || null };
  }).filter(entry => entry.product);

  if (!cardEntries.length) return;

  const optionGroup = name => {
    const n = String(name || '').trim().toLowerCase();
    if (!n || n === 'title') return '';
    if (n.includes('colour') || n.includes('color')) return 'colour';
    if (n === 'size' || n.includes('size')) return 'size';
    if (
      n.includes('print placement') ||
      n.includes('print position') ||
      n.includes('placement') ||
      n.includes('back print') ||
      n === 'print'
    ) return 'print';
    return '';
  };

  const values = { size: new Set(), colour: new Set(), print: new Set() };
  products.forEach(product => {
    (product.options || []).forEach(option => {
      const group = optionGroup(option?.name);
      if (!group) return;
      (option.values || []).forEach(value => {
        const clean = String(value || '').trim();
        if (clean) values[group].add(clean);
      });
    });
  });

  const params = new URLSearchParams(location.search);
  const stateKeys = {
    size: 'pf_size',
    colour: 'pf_colour',
    print: 'pf_print',
    availability: 'pf_availability',
    min: 'pf_min',
    max: 'pf_max'
  };

  const selectedFromUrl = key => new Set(params.getAll(stateKeys[key]).filter(Boolean));

  const panel = document.createElement('div');
  panel.className = 'pv27-filter-panel pv27-filter-panel--fallback';
  panel.setAttribute('data-v27-product-filters', '');

  const form = document.createElement('form');
  form.className = 'pv27-filter-form';
  form.action = location.pathname;
  form.method = 'get';

  const head = document.createElement('div');
  head.className = 'pv27-filter-form__head';
  const heading = document.createElement('strong');
  heading.textContent = 'Filter products';
  const clear = document.createElement('a');
  clear.href = location.pathname;
  clear.textContent = 'Clear all';
  clear.hidden = true;
  head.append(heading, clear);

  const groups = document.createElement('div');
  groups.className = 'pv27-filter-groups';

  const naturalSort = (a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });

  const makeListGroup = (key, label, entries, selected, labels = null) => {
    const details = document.createElement('details');
    details.className = 'pv27-filter-group';
    details.dataset.v27FilterGroup = key;

    const summary = document.createElement('summary');
    summary.append(document.createTextNode(label));

    const body = document.createElement('div');
    body.className = 'pv27-filter-group__body';

    const setBadge = () => {
      summary.querySelector('span')?.remove();
      const count = body.querySelectorAll('input:checked').length;
      if (!count) return;
      const badge = document.createElement('span');
      badge.textContent = String(count);
      summary.appendChild(badge);
    };

    const sorted = [...entries].sort(naturalSort);
    if (!sorted.length) {
      const note = document.createElement('div');
      note.className = 'pv27-filter-value pv27-filter-empty-note';
      const text = document.createElement('span');
      text.textContent = `No ${label.toLowerCase()} options on this collection`;
      note.appendChild(text);
      body.appendChild(note);
    } else {
      sorted.forEach(value => {
        const row = document.createElement('label');
        row.className = 'pv27-filter-value';

        const input = document.createElement('input');
        input.type = 'checkbox';
        input.value = value;
        input.dataset.v27FilterValue = key;
        input.checked = selected.has(value);

        const text = document.createElement('span');
        text.textContent = labels?.[value] || value;

        row.append(input, text);
        body.appendChild(row);
      });
    }

    body.addEventListener('change', setBadge);
    setBadge();
    if (selected.size) details.open = true;
    details.append(summary, body);
    groups.appendChild(details);
  };

  makeListGroup('size', 'Size', values.size, selectedFromUrl('size'));
  makeListGroup('colour', 'Colour', values.colour, selectedFromUrl('colour'));
  makeListGroup('print', 'Print Placement', values.print, selectedFromUrl('print'));

  const availabilitySelected = selectedFromUrl('availability');
  makeListGroup(
    'availability',
    'Availability',
    new Set(['in-stock', 'sold-out']),
    availabilitySelected,
    { 'in-stock': 'In stock', 'sold-out': 'Sold out' }
  );

  const prices = products.map(product => Number(product.price) / 100).filter(Number.isFinite);
  const maxPrice = prices.length ? Math.ceil(Math.max(...prices)) : 0;
  const priceDetails = document.createElement('details');
  priceDetails.className = 'pv27-filter-group';
  priceDetails.dataset.v27FilterGroup = 'price';

  const priceSummary = document.createElement('summary');
  priceSummary.append(document.createTextNode('Price'));

  const priceBody = document.createElement('div');
  priceBody.className = 'pv27-filter-group__body';

  const priceWrap = document.createElement('div');
  priceWrap.className = 'pv27-price-filter';

  const minInput = document.createElement('input');
  const maxInput = document.createElement('input');

  [
    ['From', minInput, stateKeys.min, params.get(stateKeys.min) || '', '0'],
    ['To', maxInput, stateKeys.max, params.get(stateKeys.max) || '', String(maxPrice)]
  ].forEach(([caption, input, name, value, placeholder]) => {
    const label = document.createElement('label');
    const span = document.createElement('span');
    span.textContent = caption;
    input.type = 'number';
    input.name = name;
    input.min = '0';
    input.max = String(maxPrice);
    input.step = '1';
    input.value = value;
    input.placeholder = placeholder;
    label.append(span, input);
    priceWrap.appendChild(label);
  });

  const updatePriceBadge = () => {
    priceSummary.querySelector('span')?.remove();
    if (!minInput.value && !maxInput.value) return;
    const badge = document.createElement('span');
    badge.textContent = '1';
    priceSummary.appendChild(badge);
  };

  minInput.addEventListener('input', updatePriceBadge);
  maxInput.addEventListener('input', updatePriceBadge);
  updatePriceBadge();
  if (minInput.value || maxInput.value) priceDetails.open = true;

  priceBody.appendChild(priceWrap);
  priceDetails.append(priceSummary, priceBody);
  groups.appendChild(priceDetails);

  const applyButton = document.createElement('button');
  applyButton.className = 'pv27-filter-apply';
  applyButton.type = 'submit';
  applyButton.textContent = 'Apply filters';

  form.append(head, groups, applyButton);
  panel.appendChild(form);
  toolbar.insertBefore(panel, toolbar.querySelector('.pv27-sort-form'));

  const selections = key => new Set(
    Array.from(panel.querySelectorAll(`input[data-v27-filter-value="${key}"]:checked`)).map(input => input.value)
  );

  const optionValuesForProduct = (product, group) => {
    const output = [];
    (product.options || []).forEach(option => {
      if (optionGroup(option?.name) !== group) return;
      (option.values || []).forEach(value => output.push(String(value || '').trim()));
    });
    return output.filter(Boolean);
  };

  const matchesAny = (product, group, selected) => {
    if (!selected.size) return true;
    const productValues = optionValuesForProduct(product, group);
    return productValues.some(value => selected.has(value));
  };

  const persistState = filterState => {
    const next = new URL(location.href);
    Object.values(stateKeys).forEach(key => next.searchParams.delete(key));

    ['size', 'colour', 'print', 'availability'].forEach(key => {
      filterState[key].forEach(value => next.searchParams.append(stateKeys[key], value));
    });
    if (filterState.min !== '') next.searchParams.set(stateKeys.min, filterState.min);
    if (filterState.max !== '') next.searchParams.set(stateKeys.max, filterState.max);

    history.replaceState({}, '', `${next.pathname}${next.search}${next.hash}`);
  };

  const reconcile = () => {
    let visible = 0;
    cardEntries.forEach(({ card }) => {
      const hiddenByStyle = card.dataset.pv27StyleHidden === 'true';
      const hiddenByProduct = card.dataset.pv27ProductHidden === 'true';
      const show = !hiddenByStyle && !hiddenByProduct;
      card.hidden = !show;
      if (show) visible += 1;
    });

    const count = section.querySelector('.pv27-collection-count strong');
    if (count) count.textContent = String(visible);

    const empty = section.querySelector('[data-v27-style-empty]');
    if (empty) {
      empty.hidden = visible > 0;
      if (!visible) empty.textContent = 'No products match those filters. Try clearing one or more options.';
    }
  };

  const apply = ({ persist = true } = {}) => {
    const filterState = {
      size: selections('size'),
      colour: selections('colour'),
      print: selections('print'),
      availability: selections('availability'),
      min: minInput.value.trim(),
      max: maxInput.value.trim()
    };

    const min = filterState.min === '' ? null : Number(filterState.min);
    const max = filterState.max === '' ? null : Number(filterState.max);

    cardEntries.forEach(({ card, product }) => {
      const price = Number(product.price) / 100;
      const availabilityMatch =
        !filterState.availability.size ||
        (filterState.availability.has('in-stock') && product.available === true) ||
        (filterState.availability.has('sold-out') && product.available === false);

      const match =
        matchesAny(product, 'size', filterState.size) &&
        matchesAny(product, 'colour', filterState.colour) &&
        matchesAny(product, 'print', filterState.print) &&
        availabilityMatch &&
        (min === null || price >= min) &&
        (max === null || price <= max);

      card.dataset.pv27ProductHidden = match ? 'false' : 'true';
    });

    const hasFilters =
      filterState.size.size ||
      filterState.colour.size ||
      filterState.print.size ||
      filterState.availability.size ||
      filterState.min !== '' ||
      filterState.max !== '';

    clear.hidden = !hasFilters;
    if (persist) persistState(filterState);
    reconcile();
  };

  const reset = () => {
    panel.querySelectorAll('input[type="checkbox"]').forEach(input => { input.checked = false; });
    minInput.value = '';
    maxInput.value = '';
    panel.querySelectorAll('.pv27-filter-group summary span').forEach(node => node.remove());
    panel.querySelectorAll('.pv27-filter-group').forEach(details => { details.open = false; });
    cardEntries.forEach(({ card }) => { card.dataset.pv27ProductHidden = 'false'; });
    clear.hidden = true;

    const next = new URL(location.href);
    Object.values(stateKeys).forEach(key => next.searchParams.delete(key));
    history.replaceState({}, '', `${next.pathname}${next.search}${next.hash}`);
    reconcile();
  };

  form.addEventListener('submit', event => {
    event.preventDefault();
    apply();
  });

  clear.addEventListener('click', event => {
    event.preventDefault();
    reset();
  });

  window.PV27CollectionFilters = { reconcile, apply, reset };

  const sortForm = toolbar.querySelector('.pv27-sort-form');
  sortForm?.addEventListener('submit', () => {
    Object.values(stateKeys).forEach(name => {
      sortForm.querySelectorAll(`input[name="${name}"]`).forEach(input => input.remove());
    });
    const current = new URLSearchParams(location.search);
    Object.values(stateKeys).forEach(name => {
      current.getAll(name).forEach(value => {
        const hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = name;
        hidden.value = value;
        sortForm.appendChild(hidden);
      });
    });
  });

  apply({ persist: false });
})();
